import styled from '@emotion/styled'
import { Button } from 'antd'
import { css } from '@emotion/core'
import { Link } from 'react-router-dom'

export const BaseStyledButton = css`
  background-color: var(--main-button-bg-color);
  border: 1px solid var(--main-button-bg-color);
  height: 34px;
  line-height: 32px;
  text-align: center;
  color: var(--main-button-text-color);
  padding: 0 16px;
  &:hover,
  &:focus {
    background-color: transparent;
    border-color: var(--main-button-bg-color);
    color: var(--main-button-bg-color);
  }
`
export const BaseStyledButtonNew = css`
  background-color: var(--main-button-bg-color);
  border: 1px solid var(--main-button-bg-color);
  width: 80px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  color: var(--main-button-text-color);
  padding: 0;
  margin-top: 2px;
  &:hover,
  &:focus {
    background-color: #f12a1b;
    border-color: #f12a1b;
    color: #fff;
  }
`
export const StyledButton = styled.button`
  ${BaseStyledButton}
`
export const StyledAntDButton = styled(Button)`
  ${BaseStyledButton}
`
export const StyledAntDButtonNew = styled(Button)`
  ${BaseStyledButtonNew}
`
export const StyledLinkButton = styled(Link)`
  ${BaseStyledButton}
`
export const StyledAnchorButton = styled.a`
  ${BaseStyledButton}
`
